module.exports = __webpack_public_path__ + "img/classroom_4.a54d7ce4.jpg";